import type { WidgetType } from '@/services/domain/services/forms/types'

export const TEXTMAGIC_WIDGET_PREVIEW_ID = 'textmagic_widget_preview_id'
export const TEXTMAGIC_WIDGET_PREVIEW_WRAPPER_ID = 'textmagic-widget-preview-wrapper'

export const createWidgetScriptTag = (code: string, type: WidgetType) => {
  const src = `${import.meta.env.VUE_APP_WIDGET_URL}/widget-script.js`
  return `<script src="${src}" data-code="${code}" data-type="${type}" defer></script>`
}

export const createMessengerWidgetScriptTag = (code: string, isPreview = false) => {
  const path = import.meta.env.VUE_APP_WIDGET_ITEMS_URL || import.meta.env.VUE_APP_WIDGET_URL
  const src = `${path}/messenger-widget-script.js`
  const suffix = isPreview ? `?_=${Date.now()}` : ''

  const script = document.createElement('script')
  script.src = `${src}${suffix}`
  script.dataset.code = code
  script.defer = true
  if (isPreview) {
    script.id = TEXTMAGIC_WIDGET_PREVIEW_ID
    script.dataset.wrapperId = TEXTMAGIC_WIDGET_PREVIEW_WRAPPER_ID
    script.dataset.isPreview = 'true'
  }

  return script.outerHTML
}

export const removeMessengerWidgetPreviewScriptTag = () => {
  const script = document.getElementById(TEXTMAGIC_WIDGET_PREVIEW_ID)
  const wrapperId = script?.dataset.wrapperId || TEXTMAGIC_WIDGET_PREVIEW_WRAPPER_ID
  const wrapper = document.getElementById(wrapperId)
  if (script) {
    script.remove()
  }
  if (wrapper) {
    wrapper.remove()
  }
}

const addedScripts = new Set<string>()
const pendingScripts = new Map<string, Promise<boolean>>()

export const loadScript = (src: string, scriptElementAttributes?: Record<string, string>) => {
  if (addedScripts.has(src)) {
    return Promise.resolve(true)
  }

  const pendingScript = pendingScripts.get(src)
  if (pendingScript) {
    return pendingScript
  }

  const promise = new Promise<boolean>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.async = true

    if (scriptElementAttributes) {
      for (const [key, value] of Object.entries(scriptElementAttributes)) {
        script.setAttribute(key, value)
      }
    }

    script.onload = () => {
      pendingScripts.delete(src)
      addedScripts.add(src)
      resolve(true)
    }

    script.onerror = (event) => {
      const err = new Error(`Failed to load script: ${src}`)
      ;(err as any).event = event
      pendingScripts.delete(src)
      reject(err)
    }

    script.onabort = (event) => {
      const err = new Error(`Script loading aborted: ${src}`)
      ;(err as any).event = event
      pendingScripts.delete(src)
      reject(err)
    }

    document.body.appendChild(script)
  })

  pendingScripts.set(src, promise)
  return promise
}
